/**
 * Whether a day has anything drawn yet: a route on it with a line. A plan's
 * first route has no day until there's a second, so it counts as day 1. Pure.
 */
export function dayHasLine(
  routes: { [key: string]: { day?: number; lineStrings?: unknown[] } | undefined } | null | undefined,
  dayNumber: number
): boolean {
  return Object.values(routes ?? {}).some(route =>
    !!route && (route.day ?? 1) === dayNumber && (route.lineStrings?.length ?? 0) > 0);
}
